import { getSubjectNames } from "../lib/corpusApi";
import { useAsyncData } from "./useAsyncData";

/**
 * The readable name of each MeSH subject (`mesh:<descriptor UI>`), by subject. Loads on mount, so
 * give the component that calls it a `key` made of the subjects: a new list then loads afresh.
 * Names are display only: none is known while they load, for a subject the table has no name for,
 * or when the lookup fails, and the caller shows such a subject by its id.
 */
export function useSubjectNames(subjects: string[]): Record<string, string> {
  const names = useAsyncData(() =>
    subjects.length > 0 ? getSubjectNames(subjects) : Promise.resolve({})
  );
  return names.data ?? {};
}
